var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"productnotfound"},[_c('img',{staticClass:"productnotfoundimg",attrs:{"src":_vm.itemnotfound}}),_c('span',{staticStyle:{"font-size":"2rem"}},[_vm._v("No results found.")]),_c('br'),_c('span',{staticStyle:{"color":"#778899"}},[_vm._v("Your search was too specific, please try searching with another term.")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }